import { FC } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Language } from "../../types/Language";
import { ResourcesService } from "../../services/ResourcesService";

type FormGroupSelectLanguageProps = {
    controlId: string,
    disabled: boolean,
    setValue: Function,
    lang: Language,
    defaultValue?: string | number | readonly string[] | undefined,
};

export const FormGroupSelectLanguage: FC<FormGroupSelectLanguageProps> = ({ controlId, disabled, setValue, lang, defaultValue }) =>
    <Form.Group as={Row} className="mb-3" controlId={controlId}>
        <Form.Label column sm="2">{ResourcesService.translate('Language', lang)}</Form.Label>
        <Col sm="10">
            <Form.Select disabled={disabled} defaultValue={defaultValue} onChange={e => setValue(e.currentTarget.value)}>
                <option value={"EN"}>EN</option>
                <option value={"BG"}>BG</option>
                <option value={"RO"}>RO</option>
            </Form.Select>
        </Col>
    </Form.Group>